var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mar-b-100",attrs:{"id":"user-manage-detail-login-diary"}},[_c('div',{staticClass:"page-content-table"},[_c('ipub-table',{attrs:{"columns":_vm.columns,"pagination":_vm.pagination,"dataSource":_vm.dataSource}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }